import { Injectable } from "@angular/core";
import { CanActivate, Router, UrlTree } from "@angular/router";
import { AuthNewService } from "src/auth/services/auth-new.service";
import { canManageFeesConfiguration } from "../app.constants";

@Injectable({
  providedIn: "root",
})
export class FeesConfigurationGuardService implements CanActivate {
  constructor(
    private auth: AuthNewService,
    private router: Router,
  ) {}

  canActivate(): boolean | UrlTree {
    return canManageFeesConfiguration(this.auth.userValue?.payload)
      ? true
      : this.router.createUrlTree(["/app/expenses/expenses"]);
  }
}
